import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import HomeRouteCard from '../components/Home/HomeRouteCard';
import HomeGroupCard from '../components/Home/HomeGroupCard';

const getUserAndRole = () => {
    let userId = sessionStorage.getItem('userId') ? parseInt(sessionStorage.getItem('userId')) : 0;
    let roleId = sessionStorage.getItem('roleId') ? parseInt(sessionStorage.getItem('roleId')) : 0;
    return { userId, roleId }
};

const getRoutes = () => {
    let listToReturn = [];
    let { roleId } = getUserAndRole();
    let routes = [
        {
            roles: [1, 2, 3, 4],
            group: "Operación",
            title: "Inventario",
            description: "Consulta y gestiona existencias",
            mainUrl: "/inventory",
            mainLabel: "Ver inventario",
        },
        {
            roles: [1, 2, 4],
            group: "Operación",
            title: "Consumibles",
            description: "Control de consumibles",
            mainUrl: "/supplies",
            mainLabel: "Ver consumibles",
        },
        {
            roles: [1, 2, 3, 4],
            group: "Operación",
            title: "Reportes",
            description: "Reportes y exportaciones",
            mainUrl: "/reports",
            mainLabel: "Ver reportes",
        },
        {
            roles: [1, 2],
            group: "Administración",
            title: "Usuarios",
            description: "Altas, edición e inactivación",
            mainUrl: "/users",
            mainLabel: "Administrar usuarios",
        },
        {
            roles: [1],
            group: "Administración",
            title: "Auditoría de accesos",
            description: "Logs de inicio de sesión",
            mainUrl: "/login-logs",
            mainLabel: "Ver logs",
        },
        {
            roles: [1, 2, 3, 4],
            group: "Configuraciones",
            title: "Ubicaciones",
            description: "Altas, edición e inactivación",
            mainUrl: "/locations",
            mainLabel: "Administrar ubicaciones",
        },
        {
            roles: [1, 2, 3, 4],
            group: "Configuraciones",
            title: "Categorías",
            description: "Altas, edición e inactivación",
            mainUrl: "/itemCategories",
            mainLabel: "Administrar categorías",
        },
        {
            roles: [1, 2, 3, 4],
            group: "Configuraciones",
            title: "Estados",
            description: "Altas, edición e inactivación",
            mainUrl: "/itemStatus",
            mainLabel: "Administrar estados",
        },
        {
            roles: [1, 2, 3, 4],
            group: "Configuraciones",
            title: "Unidad de medida",
            description: "Altas, edición e inactivación",
            mainUrl: "/itemUnits",
            mainLabel: "Administrar unidades de medida",
        },
        {
            roles: [1, 2, 3, 4],
            group: "Configuraciones",
            title: "Folios",
            description: "Altas, edición e inactivación",
            mainUrl: "/folios",
            mainLabel: "Administrar folios",
        },
        {
            roles: [1],
            group: "Importaciones",
            title: "Importación de Excel",
            description: "Carga y previsualiza archivos Excel para conciliación",
            mainUrl: "/excel-reports",
            mainLabel: "Abrir módulo",
        },
        {
            roles: [1, 2, 4],
            group: "Conciliación",
            title: "Conciliación de Inventario",
            description: "Compara Excel contra inventario y folios del sistema",
            mainUrl: "/inventory-reconciliation",
            mainLabel: "Abrir conciliación",
        },
    ]

    for (let route of routes) {
        if (route.roles && route.roles.includes(roleId)) {
            listToReturn.push(route);
        }
    }

    return listToReturn;
};

const groupBy = (routes) => {
    return routes.reduce((acc, r) => {
        acc[r.group] ??= [];
        acc[r.group].push(r);
        return acc;
    }, {});
};

function Home() {
    const [grouped, setGrouped] = useState({});

    useEffect(() => {
        const routes = getRoutes();
        setGrouped(groupBy(routes));
    }, []);

    return (
        <Container fluid className="py-3">
            <Row className="g-3 align-items-start">
                {/* Operación */}
                {(grouped["Operación"] || []).map((item) => (
                    <Col key={item.title} xs={12} md={6} xl={4} xxl={3}>
                        <HomeRouteCard element={item} />
                    </Col>
                ))}

                {/* Administración */}
                {(grouped["Administración"] || []).map((item) => (
                    <Col key={item.title} xs={12} md={6} xl={4} xxl={3}>
                        <HomeRouteCard element={item} />
                    </Col>
                ))}

                {/* Importaciones */}
                {(grouped["Importaciones"] || []).map((item) => (
                    <Col key={item.title} xs={12} md={6} xl={4} xxl={3}>
                        <HomeRouteCard element={item} />
                    </Col>
                ))}

                {/* Configuraciones */}
                {(grouped["Configuraciones"] || []).length ? (
                    <Col xs={12} xl={8} xxl={6}>
                        <HomeGroupCard title="Configuraciones" description="Catálogos del sistema" items={grouped["Configuraciones"]} />
                    </Col>
                ) : null}
            </Row>
        </Container>
    );
};

export default Home;